import { render } from "./GiveFeedback.vue?vue&type=template&id=d84ae474"
import script from "./GiveFeedback.vue?vue&type=script&lang=js"
export * from "./GiveFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__